



































import { defineComponent, useContext } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';

export default defineComponent({
  components: {
    AppIcon,
  },
  setup() {
    const { i18n } = useContext();

    const annotations = Array.from({ length: 6 }).map((value, index) => ({
      title: i18n.t(`Item-03.oldVintage.annotation.${index + 1}.title`).toString(),
      body: `Item-03.oldVintage.annotation.${index + 1}.body`,
    }));

    return {
      annotations,
    };
  },
});
